export const emptyDiv = '<div></div>';
export const defaultContent = [
  { header: 'Description', content: emptyDiv },
  { header: 'Rules', content: emptyDiv }
];

export const newContentBlock = { header: '', content: emptyDiv };

// export const jsonTemplate = `
// {
//   'body': {
//     'rows': [
//       {
//         'cells': [
//           1
//         ],
//         'columns': [
//           {
//             'contents': [

//             ]
//           }
//         ],
//         'values': {
//           'backgroundColor': 'rgba(255,255,255,0)',
//           'backgroundImage': {
//             'url': '',
//             'fullWidth': true,
//             'repeat': false,
//             'center': true,
//             'cover': false
//           },
//           'padding': '10px',
//           'columnsBackgroundColor': 'rgba(255,255,255,0)',
//           'selectable': true,
//           'draggable': true,
//           'deletable': true
//         }
//       }
//     ],
//     'values': {
//       'backgroundColor': '#ffffff',
//       'backgroundImage': {
//         'url': '',
//         'fullWidth': true,
//         'repeat': false,
//         'center': true,
//         'cover': false
//       },
//       'contentWidth': '500px',
//       'fontFamily': {
//         'label': 'Arial',
//         'value': 'arial,helvetica,sans-serif'
//       }
//     }
//   }
// }
// `;

// export const htmlTemplate = `
//   <!doctype html>
//   <html>
//     <head>
//       <meta charset='utf-8'>
//       <meta http-equiv='x-ua-compatible' content='ie=edge'>
//       <title></title>
//       <meta name='description' content=''>
//       <meta name='viewport' content='width=device-width, initial-scale=1'>
//       <link href='https://editor.unlayer.com/web.css' rel='stylesheet' type='text/css'>

//     </head>
//     <body>

//   <div style='min-height: 100vh; background-color: #ffffff; font-family: arial,helvetica,sans-serif;'>

//     <div style=' background-color: rgba(255,255,255,0); padding: 10px;'>
//       <div style='max-width: 500px; background-color: rgba(255,255,255,0);' class='container'>
//         <div class='row'>

//     <div class='col-md-12' >

//     </div>

//         </div>
//       </div>
//     </div>

//   </div>

//     </body>
//   </html>
// `;



// WEBPACK FOOTER //
// ./src/components/forms/constants/eventContent.js